import { CORE_PLUGIN } from "@/core"
import type { ConsolePageOption, ConsolePageService, Plugin } from "@/plugins"
import { PLUGIN_CONSOLE_PAGE } from "@/plugins/builtin/BuiltinPluginSymbol"
import { container, injectable, instanceCachingFactory, registry, singleton } from "tsyringe"
import type { App } from "vue"
import UserProfile from "./components/UserProfile.vue"
import ConsoleLogo from "./components/ConsoleLogo.vue"
import SystemLogo from "./components/SystemLogo.vue"
import SigninDecoratorPage from './components/SigninDecoratorPage.vue'
import DefaultAvatar from './components/DefaultAvatar.vue'

export const AppMiscPluginOptionsInjectKey = 'AppMiscPluginOptionsInjectKey'

// const useMiscStore = defineStore('miscellaneous', {
// })

@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<unknown, unknown>>((c) =>
      c.resolve(MiscPlugin)
    ),
  },
])
@injectable()
export class MiscPlugin implements Plugin<unknown, unknown> {
  id: string | symbol = ''
  options: unknown
  service: unknown

  init(app: App<Element>): void {
    // app.component('AppGotoHelp', GotoHelp)
    app.component("FlashbaseUserProfileControl", UserProfile)
    app.component("FlashbaseSigninDecorator", SigninDecoratorPage)
    app.component("FlashbaseSystemLogo", SystemLogo)
    app.component("FlashbaseConsoleLogo", ConsoleLogo)
    app.component("FlashbaseDefaultAvatar", DefaultAvatar)
    const plugin = container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(PLUGIN_CONSOLE_PAGE)
    // plugin.service.addHeadRight('app-goto-help')
    plugin.service.addHeadRight('FlashbaseUserProfileControl')
    plugin.service.setLeftLogo("FlashbaseConsoleLogo")
  }

  initialized(app: App<Element>): void {

  }
}
